import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { OAuthService } from 'angular-oauth2-oidc';
import { TokenService } from 'src/app/core/interceptors/token.service';
import { ToastService } from 'src/app/core/services/toast.service';
import { ApiloaderService } from 'src/app/shared/loaders/apiloader/apiloader.service';
import { NotificationService } from 'src/app/shared/notification/notification.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorhanderService {
  constructor(
    private router: Router,
    public notificationService: NotificationService,
    public toastService: ToastService,
    private oauthService: OAuthService,
    private tokenService: TokenService,
    private apiloader: ApiloaderService
  ) {}

  handle(e: unknown, hdrString?: string, showdate = true) {
    let message = '';

    if (e instanceof Error) {
      message = e.message;
    } else if (e instanceof HttpErrorResponse) {
      if(e.status === 401) {
        this.toastService.error('Inactive session has been terminated by server.', `Session end - [${new Date().toString()}] `, {
          titleClass: 'h5',
          timeOut: 20000,
          positionClass: 'toast-top-right',
        });
        this.oauthService.refreshToken().then((value) =>{
          this.toastService.info('Session restored, please try again.','Session restored');
        }).catch(()=>{
          this.toastService.warning('Unable to restore session, please log in again and try again','Session unavailable');

        });
        return;
      }

      if (e.error) {
        message = e.error.message ?? e.error.error ?? '';
      } else {
        message = e.message || '';
      }

      hdrString &&= ` ${e.status} ${e.statusText}: ${e.name}`;
    } else if (typeof e == 'string') {
      //message = 'We have experienced a server disconnect, please check connection or wait for server availability and try again.';
      message = 'Server Unavailable';
      this.apiloader.isAPIOffline.next(true);
    }

    let showdateStr = '';
    if (showdate) {
      showdateStr = `[${new Date().toString()}] `;
    }

    // this.notificationService.setAds([{
    //       type:'error',
    //       title: `${showdateStr}${hdrString || ''}`,
    //       body: message,
    //       options: { closeButton: false, tapToDismiss: true, progressBar: false, newestOnTop: true, timeOut: 20000}
    //   }]);

    this.toastService.error(message, `${showdateStr}${hdrString || ''}`, {
      titleClass: 'h5',
      timeOut: 20000,
      positionClass: 'toast-top-right',
    });
    // handle the error message here
  }

  handleString(e: string, hdrString?: string, showdate?: boolean, warningToast?: boolean) {
    let message = 'We are experiencing some issues, we will attend to this';
    const showdateStr = new Date().toLocaleString();

    hdrString = hdrString || '';
    if (showdate) {
      hdrString = `${showdateStr}: ${hdrString}`;
    }

    if (typeof e === 'string') {
      message = e;
    }

    this.notificationService.setAds([{
      type: warningToast? 'warn': 'error',
      title: hdrString,
      body: message,
      options: { closeButton: false, tapToDismiss: true, progressBar: false, newestOnTop: true}
    }]);

    // if (warningToast) {
    //   this.toastrService.warning(message, hdrString, { newestOnTop: true, positionClass: 'toast-top-center' });
    // } else {
    //   this.toastrService.error(message, hdrString, {
    //     newestOnTop: true,
    //     disableTimeOut: true,
    //     closeButton: true,
    //     positionClass: 'toast-top-center',
    //   });
    // }
  }

  handleStack(e: any, hdrString?: string, showdate?: boolean) {
    const showdateStr = new Date().toLocaleString();

    hdrString = hdrString || '';
    if (showdate) {
      hdrString = `${showdateStr}: ${hdrString}`;
    }

    let estack = '';
    if (Array.isArray(e)) {
      e.forEach((stack) => {
        estack += '[' + stack.className + '] ' + stack.methodName + '\n\r';
      });
    } else {
      estack = e;
    }

     this.notificationService.setAds([{
      type: 'error',
      title: hdrString,
      body: estack,
      options: { closeButton: false, tapToDismiss: true, progressBar: false, newestOnTop: true}
    }]);
    // this.toastrService.error(estack, hdrString, {
    //   newestOnTop: true,
    //   enableHtml: true,
    //   disableTimeOut: true,
    //   closeButton: true,
    //   messageClass: 'text-start',
    //   positionClass: 'toast-top-center',
    // });
  }

  handleOffline(e: string, hdrString?: string) {
    this.apiloader.isAPIOffline.next(true);
    this.apiloader.isLoading.next(false);
    this.notificationService.setAds([{
      type: 'error',
      title: hdrString,
      body: 'Server non-responsive!',
      options: { closeButton: false, tapToDismiss: true, progressBar: false, newestOnTop: true}
    }]);
    // this.toastrService.error(`Server non-responsive!`, `${hdrString}`, {
    //   newestOnTop: true,
    //   disableTimeOut: true,
    //   closeButton: true,
    //   positionClass: 'toast-top-center',
    // });

    // handle the error message here
  }

  handleServerSideError(error: HttpErrorResponse): boolean {
    let handled = false;

    switch (error.status) {
      case 304:
      case 404: {
        const message1 = error.message || '';

        const hdrString1 = error.statusText || `NOT Modified/Updated: `;

        const showdateStr1 = new Date().toLocaleString() + ' -';
        this.notificationService.setAds([{
          type: 'error',
          title: `${showdateStr1}${hdrString1 || ''}`,
          body: message1,
          options: { closeButton: false, tapToDismiss: true, progressBar: false, newestOnTop: true, extendedTimeOut: 15000}
        }]);
        // this.toastrService.error(message1, `${showdateStr1}${hdrString1 || ''}`, {
        //   positionClass: 'toast-top-center',
        //   extendedTimeOut: 15000,
        //   newestOnTop: true,
        // });
        handled = false;
        break;
      }
      case 401: {
        //we don't want to redirect people to the login page when they're already on
        //the login page
        if (this.router.url != '/home') {
          //this.alertService.info("Please login again.", { keepAfterRouteChange: false });
          //this.toastrService.info('WHO!? Please Login!');
          this.notificationService.setAds([{
          title: '',
          body: 'WHO!? Please Login!',
          options: { closeButton: false, tapToDismiss: false, progressBar: false, newestOnTop: true}
        }]);
          // Clear auth state before logging out for 401 errors
          this.tokenService.clearAuthState();
          this.oauthService.logOut();
          handled = true;
        }
        break;
      }
      case 403: {
        //this.alertService.info("Please login again.", { keepAfterRouteChange: false });
        //this.authenticationService.logout();
        this.notificationService.setAds([{
          title: '',
          body: 'Logging out!',
          options: { closeButton: false, tapToDismiss: false, progressBar: false, newestOnTop: true}
        }]);
        handled = true;
        break;
      }
      case 417: {
        handled = false;

        break;
      }
      case 422: {
        const hdrString422 = ` ${error.url}[${error.status}]: `;

        const showdateStr422 = `${new Date().toLocaleString()} -`;

        this.notificationService.setAds([{
          type: 'error',
          title: `${showdateStr422}${hdrString422 || ''}`,
          body: `${error.error.localizedMessage}`,
          options: { closeButton: false, tapToDismiss: true, progressBar: false, newestOnTop: true, extendedTimeOut: 5000}
        }]);

        // this.toastrService.error(`${error.error.localizedMessage}`, `${showdateStr422}${hdrString422 || ''}`, {
        //   positionClass: 'toast-top-center',
        //   extendedTimeOut: 5000,
        //   newestOnTop: true,
        //   tapToDismiss: true,
        // });
        handled = true;
        break;
      }
      // case 500:
      //   let ms = JSON.parse(error.error);
      //   let message2 = JSON.parse(ms, (neskey, nesval) => {
      //     let nested2 = JSON.stringify(nesval);
      //     let errstr = JSON.parse(nested2, (neskey1, nesval1) => {
      //       return nesval1;
      //     });
      //     return errstr;
      //   });
      //   let showdateStr2 = `${new Date().toLocaleString()} -`;

      //   this.toastrService.error(`${message2}`, `${showdateStr2}`, { positionClass: 'toast-top-center', extendedTimeOut: 5000, newestOnTop: true, tapToDismiss: true });
      //   handled = false;
      //   break;
      case 0:
        this.handleOffline(error.message || error.error.message, 'Server OFFLINE');
        this.apiloader.isAPIOffline.next(true);
        handled = true;
        break;
      default: {
        let message = `${error.message || error.error.message}`;
        // if (error.error) {
        //   message = error.error.message;
        // } else {
        //   message = error.message;
        // }
        const hdrString = ` ${error.error.path}[${error.status}]: `;
        if (error.error.path === '/biometric/user-api/verify-finger') {
          message = 'No Finger Provided';
        }
        let showdateStr = '';
        showdateStr = `${new Date().toLocaleString()} -`;
        this.notificationService.setAds([{
          type: 'error',
          title: `${showdateStr}${hdrString || ''}`,
          body: message,
          options: { closeButton: false, tapToDismiss: true, progressBar: false, newestOnTop: true, extendedTimeOut: 5000}
        }]);
        // this.toastrService.error(message, `${showdateStr}${hdrString || ''}`, {
        //   positionClass: 'toast-top-center',
        //   extendedTimeOut: 5000,
        //   newestOnTop: true,
        // });
        handled = true;
        // handle the error message here
        break;
      }
    }
    return handled;
  }
}
